import { component } from 'picoapp';
import { fetchCart } from '~/js/lib/cart/cart';

export default component((node: HTMLFormElement, ctx: Picoapp.Ctx) => {
  const submit = async (event) => {
    event.preventDefault();

    const formData = new FormData(node);
    const btn: HTMLButtonElement = node.querySelector('[data-submit-btn]');
    btn.textContent = theme.strings.adding;
    btn.disabled = true;

    await fetch(`${node.action}.js`, {
      method: node.method,
      body: formData,
    });

    await fetchCart().then((response) => {
      ctx.emit('cart:updated', { cart: response });
      ctx.emit('cart:drawer:toggle', ({ cartDrawerOpen: true }));
      btn.disabled = false;
      btn.textContent = theme.strings.addToCart;
    });
  };

  node.addEventListener('submit', submit);
});
